import { Chip, Stack, Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getLevelColorFromAQI, getLevelFromAQI } from './AQIDetails.utils';

type AQIStatValueProps = {
  aqi: number;
};

export const AQIStatValue = (props: AQIStatValueProps): JSX.Element => {
  const { aqi } = props;
  const { t } = useTranslation();

  const backgroundColor = getLevelColorFromAQI(aqi);

  return (
    <Stack alignItems="center" spacing={0.5}>
      <Chip
        label={aqi}
        variant="watchduty-basic"
        size="small"
        sx={(theme: Theme) => ({
          fontSize: theme.typography.body1.fontSize,
          backgroundColor,
          color: theme.palette.getContrastText(backgroundColor),
        })}
      />
      <Typography
        variant="subtitle1"
        color="textSecondary"
        fontWeight="fontWeightBold"
        maxWidth={160}
      >
        {getLevelFromAQI(t, aqi)}
      </Typography>
    </Stack>
  );
};
